import React from 'react'
import { Tooltip } from '@mui/material'
import VerifiedIcon from '@mui/icons-material/Verified';
import WarningIcon from '@mui/icons-material/Warning';
import ErrorIcon from '@mui/icons-material/Error';
import GroupIcon from '@mui/icons-material/Group';

export default function SampleNameAndBadge({sample : {name, display_name, sequence_verified, sequencing_notes, owner}}) {
  const badge_params = {sx: {fontSize: 16, marginLeft: 1, verticalAlign: 'middle'}}
  return (
    <>
      {display_name || name}
      {sequence_verified === true && 
        <Tooltip title={sequencing_notes || "Sequence verified"}>
          <VerifiedIcon {...badge_params} />
        </Tooltip>
      }
      {sequence_verified === "acceptable" && 
        <Tooltip title={sequencing_notes || "Sequence acceptable with caution"}>
          <WarningIcon color="warning" {...badge_params} />
        </Tooltip>
      }
      {sequence_verified === false && 
        <Tooltip title={sequencing_notes || "Failed sequence verification"}>
          <ErrorIcon color="error" {...badge_params} />
        </Tooltip>
      }
      {owner?.is_self === false && 
        <Tooltip title={`Owned by ${owner.username}`}>
          <GroupIcon color="disabled" {...badge_params} />
        </Tooltip>
      }
    </>
  )
}
